<template>
  <div class="bg-white rounded-lg m-3 pb-3">
    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="del_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ del_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="del_success"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ del_success }}
      </div>
    </transition>
    <div class="border-b-0.5 flex justify-between items-center p-3">
      <p class="text-sm font-semibold">{{ title }}</p>

      <button
        class="bg-primary rounded-full px-10 text-sm text-white py-1 flex text-center items-center gap-1"
        @click="setShowAddHistory(itemIndex)"
      >
        <svg
          id="Layer_1"
          viewBox="0 0 24 24"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          fill="#fff"
        >
          <path
            d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
          />
        </svg>
        Add
      </button>
    </div>

    <ve-table
      :columns="itemIndex === 1 ? columns : educationColumns"
      :tableData="data"
      style="min-height: 30vh"
    >
    </ve-table>
    <div
      v-if="data?.length === 0"
      class="flex flex-col justify-center items-center h-full mt-5"
    >
      <el-empty :image-size="70" description="No Data"></el-empty>
    </div>

    <!-- Scrollable Drawer with Multiple Employment Histories -->
    <el-drawer
      title="Employment History Details"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="50%"
    >
      <div v-for="item in data" :key="item.id" class="mb-6">
        <h3 class="font-bold text-lg">{{ item.Organization }}</h3>
        <p class="italic text-sm mb-2">
          {{ item.jobTitle }} ({{ formatDate(item.StartDate) }} -
          {{ formatDate(item.EndDate) }})
        </p>
        <h4 class="font-semibold">Job Description:</h4>
        <ul class="list-disc pl-4">
          <li v-for="(desc, index) in item.JobDescription" :key="index">
            {{ desc }}
          </li>
        </ul>

        <h4 class="font-semibold mt-4">Referee Information:</h4>
        <p><strong>Name:</strong> {{ item.refereeName }}</p>
        <p><strong>Title:</strong> {{ item.refereeTitle || 'N/A' }}</p>
        <p><strong>Contact:</strong> {{ item.refereeContact }}</p>

        <!-- Divider between employment records -->
        <hr class="border-t mt-4 mb-6" />
      </div>

      <span slot="footer" class="drawer-footer">
        <el-button @click="closeDrawer">Close</el-button>
      </span>
    </el-drawer>
  </div>
</template>

<script>
import decryptData from '@/utils/decrypt';
import moment from 'moment';

export default {
  components: {},
  name: 'InformationCard',
  props: [
    'title',
    'data',
    'setShowAddHistory',
    'itemIndex',
    'get_error',
    'handleDeleteButtonClick',
    'handleEditButtonClick',
    'setIsConfirmed',
    'del_error',
    'del_success',
  ],
  data() {
    return {
      drawerVisible: false,
      showAddEmploymentHistory: false,
      columns: [
        {
          field: 'OrganizationName',
          key: 'OrganizationName',
          title: 'Organization Name',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'StartDate',
          key: 'StartDate',
          title: 'Start Date',
          headerAlign: 'left',
          align: 'center',
          renderBodyCell: ({ row }) =>
            moment(row.StartDate).format('DD/MM/YYYY'),
        },

        {
          field: 'EndDate',
          key: 'EndDate',
          title: 'End Date',
          headerAlign: 'left',
          align: 'left',
          renderBodyCell: ({ row }) => moment(row.EndDate).format('DD/MM/YYYY'),
        },
        {
          field: 'JobTitle',
          key: 'JobTitle',
          title: 'Job Title',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'JobDescription',
          key: 'JobDescription',
          title: 'Job Description',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'RefereeName',
          key: 'RefereeName',
          title: 'Referee Name',
          headerAlign: 'left',
          align: 'center',
          renderBodyCell: ({ row }) =>
            decryptData(row.RefereeName, this.$decryptionKey),
        },
        {
          field: 'RefereeTitle',
          key: 'RefereeTitle',
          title: 'Referee Title',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'RefereePhone',
          key: 'RefereePhone',
          title: 'Referee Contact',
          headerAlign: 'left',
          align: 'left',
          renderBodyCell: ({ row }) =>
            decryptData(row.RefereePhone, this.$decryptionKey),
        },

        {
          title: 'Action',
          field: '',
          key: 'action',
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger='clickToOpen'
              options={{
                placement: 'top',
                modifiers: { offset: { offset: '30px,10px' } },
              }}
            >
              <div class='bg-white p-2 shadow-md popper'>
                <button
                  class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                  style='boder-radius: 0 !important'
                  onClick={() =>
                    this.handleEditButtonClick(row, this.itemIndex)
                  }
                >
                  Edit
                </button>
                <button
                  class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                  style='boder-radius: 0 !important'
                  onClick={() =>
                    this.handleDeleteButtonClick(row, this.itemIndex)
                  }
                >
                  Delete
                </button>
              </div>

              <button slot='reference'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  id='Outline'
                  viewBox='0 0 24 24'
                  width='20'
                  height='20'
                >
                  <circle cx='12' cy='2' r='2' />
                  <circle cx='12' cy='12' r='2' />
                  <circle cx='12' cy='22' r='2' />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      educationColumns: [
        {
          field: 'InstitutionName',
          key: 'InstitutionName',
          title: 'Institution Name',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'CourseName',
          key: 'CourseName',
          title: 'CourseName',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'StartDate',
          key: 'StartDate',
          title: 'Start Date',
          headerAlign: 'left',
          align: 'center',
          renderBodyCell: ({ row }) =>
            moment(row.StartDate).format('DD/MM/YYYY'),
        },

        {
          field: 'EndDate',
          key: 'EndDate',
          title: 'End Date',
          headerAlign: 'left',
          align: 'left',
          renderBodyCell: ({ row }) => moment(row.EndDate).format('DD/MM/YYYY'),
        },
        {
          field: 'Awarded',
          key: 'Awarded',
          title: 'Awarded',
          headerAlign: 'left',
          align: 'left',
        },

        {
          title: 'Action',
          field: '',
          key: 'action',
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger='clickToOpen'
              options={{
                placement: 'top',
                modifiers: { offset: { offset: '0,10px' } },
              }}
            >
              <div class='bg-white p-2 shadow-md popper'>
                <button
                  class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                  style='boder-radius: 0 !important'
                  onClick={() =>
                    this.handleEditButtonClick(row, this.itemIndex)
                  }
                >
                  Edit
                </button>
                <button
                  class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                  style='boder-radius: 0 !important'
                  onClick={() =>
                    this.handleDeleteButtonClick(row, this.itemIndex)
                  }
                >
                  Delete
                </button>
              </div>

              <button slot='reference'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  id='Outline'
                  viewBox='0 0 24 24'
                  width='20'
                  height='20'
                >
                  <circle cx='12' cy='2' r='2' />
                  <circle cx='12' cy='12' r='2' />
                  <circle cx='12' cy='22' r='2' />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
    };
  },
  created() {
    // console.log(this.data);
  },
  methods: {
    openDrawer() {
      this.drawerVisible = true;
    },
    closeDrawer() {
      this.drawerVisible = false;
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(date).toLocaleDateString(undefined, options);
    },
  },
};
</script>

<style>
.ve-table-header-th {
  font-size: 0.65rem !important;
}
.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  tbody.ve-table-body
  tr.ve-table-body-tr
  td.ve-table-body-td,
.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  tbody.ve-table-body
  tr.ve-table-expand-tr
  td.ve-table-body-td {
  padding: 4px !important;
  font-size: 0.68rem !important;
}
</style>
